module.exports = {"header":{"my-arriva-label":"Mijn Arriva"}}


//////////////////
// WEBPACK FOOTER
// ./src/locale/nl/xc-website.json
// module id = 9+t7
// module chunks = 1